module.exports = __webpack_public_path__ + "75e18205fce7499e7e0845091b2c7f32.jpg";